import React from "react"
import {Segment} from "semantic-ui-react"
import api from "../api"
import EscalateModal from "./components/Modals/EscalateModal"

const EscalatePage = () => {
    let order = api.getOrder()
    return (
        <div className="transition-item section-full section--center ">
            <EscalateModal order={order}/>
            <Segment>
            </Segment>
        </div>
    )
}

export default EscalatePage


// WEBPACK FOOTER //
// ./src/pages/EscalatePage.js